(function () {
  function bindDiscountButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('.announcement-bar__discount-btn:not([data-copy-bound])').forEach(function (btn) {
      btn.setAttribute('data-copy-bound', 'true');
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var code = btn.getAttribute('data-discount-code');
        if (!code) return;

        var copiedLabel = btn.getAttribute('data-copied-label') || 'Copied!';
        var originalText = btn.textContent;

        function showCopied() {
          btn.classList.add('announcement-bar__discount-btn--copied');
          btn.textContent = copiedLabel;
          window.setTimeout(function () {
            btn.textContent = originalText;
            btn.classList.remove('announcement-bar__discount-btn--copied');
          }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopied).catch(function () {
            fallbackCopy(code, showCopied);
          });
        } else {
          fallbackCopy(code, showCopied);
        }
      });
    });
  }

  function fallbackCopy(text, onSuccess) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      onSuccess();
    } catch (error) {
      /* ignore */
    }
    document.body.removeChild(textarea);
  }

  function bindNewTabLinks(root) {
    var scope = root || document;
    scope
      .querySelectorAll('.announcement-bar__link--inline[target="_blank"]:not([data-new-tab-bound])')
      .forEach(function (link) {
        link.setAttribute('data-new-tab-bound', 'true');
        link.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          window.open(link.href, '_blank', 'noopener,noreferrer');
        });
      });
  }

  function init(event) {
    var scope = event && event.target ? event.target : document;
    bindDiscountButtons(scope);
    bindNewTabLinks(scope);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
